// extracted by mini-css-extract-plugin
export default {"react-tooltip":"Tooltip_react-tooltip__Piu7d","medfar-tooltip":"Tooltip_medfar-tooltip__9Kn6H"};